import { RouterModule, Routes } from '@angular/router';

// import { CanLeavePageGuard } from '../../guards/canLeavePage/can-leave-page.guard';
import { BlockEditComponent } from './containers/block-edit/block-edit.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: ':id/edit', component: BlockEditComponent /*, canDeactivate: [CanLeavePageGuard] */ },
  { path: 'add', component: BlockEditComponent /*, canDeactivate: [CanLeavePageGuard] */ },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlockRoutingModule {}
